exports.keyboard_3LetterWords = [
	'aas',
	'aba',
	'abs',
	'ace',
	'act',
	'add',
	'ads',
	'adz',
	'aff',
	'aft',
	'aga',
	'age',
	'arb',
	'arc',
	'are',
	'arf',
	'ars',
	'art',
	'ass',
	'ate',
	'att',
	'ava',
	'ave',
	'awa',
	'awe',
	'axe',
	'baa',
	'bad',
	'bag',
	'bar',
	'bas',
	'bat',
	'bed',
	'bee',
	'beg',
	'bet',
	'bra',
	'brr',
	'cab',
	'cad',
	'car',
	'cat',
	'caw',
	'cee',
	'dab',
	'dad',
	'dag',
	'daw',
	'deb',
	'dee',
	'dev',
	'dew',
	'dex',
	'ear',
	'eat',
	'ebb',
	'eff',
	'efs',
	'eft',
	'egg',
	'era',
	'ere',
	'erg',
	'err',
	'ers',
	'ess',
	'eta',
	'eve',
	'ewe',
	'fad',
	'fag',
	'far',
	'fas',
	'fat',
	'fax',
	'fed',
	'fee',
	'fer',
	'fet',
	'few',
	'fez',
	'gab',
	'gad',
	'gae',
	'gag',
	'gar',
	'gas',
	'gat',
	'ged',
	'gee',
	'get',
	'qat',
	'rad',
	'rag',
	'ras',
	'rat',
	'raw',
	'rax',
	'reb',
	'rec',
	'red',
	'ree',
	'ref',
	'reg',
	'res',
	'ret',
	'rev',
	'rex',
	'rts',
	'sab',
	'sac',
	'sad',
	'sae',
	'sag',
	'sat',
	'saw',
	'sax',
	'sea',
	'sec',
	'see',
	'seg',
	'ser',
	'set',
	'sew',
	'tab',
	'tad',
	'tae',
	'tag',
	'tar',
	'tas',
	'tat',
	'tav',
	'taw',
	'tax',
	'tea',
	'ted',
	'tee',
	'teg',
	'tet',
	'tew',
	'twa',
	'vac',
	'var',
	'vas',
	'vat',
	'vav',
	'vaw',
	'vee',
	'veg',
	'vet',
	'vex',
	'wab',
	'wad',
	'wae',
	'wag',
	'war',
	'was',
	'wat',
	'waw',
	'wax',
	'web',
	'wed',
	'wee',
	'wet',
	'zag',
	'zax',
	'zed',
	'zee',
];

exports.keyboard_4LetterWords = [
	'abas',
	'abba',
	'abbe',
	'abed',
	'abet',
	'aced',
	'aces',
	'acre',
	'acta',
	'acts',
	'adds',
	'adze',
	'afar',
	'agar',
	'agas',
	'aged',
	'agee',
	'ager',
	'ages',
	'arbs',
	'arcs',
	'area',
	'ares',
	'arfs',
	'arse',
	'arts',
	'asea',
	'ates',
	'aver',
	'aves',
	'awed',
	'awee',
	'awes',
	'axed',
	'axes',
	'baas',
	'baba',
	'babe',
	'bade',
	'bads',
	'baff',
	'bags',
	'barb',
	'bard',
	'bare',
	'barf',
	'bars',
	'base',
	'bass',
	'bast',
	'bate',
	'bats',
	'batt',
	'bawd',
	'bead',
	'bear',
	'beat',
	'beds',
	'beef',
	'beer',
	'bees',
	'beet',
	'begs',
	'berg',
	'best',
	'beta',
	'bets',
	'brad',
	'brae',
	'brag',
	'bras',
	'brat',
	'braw',
	'bred',
	'bree',
	'brew',
	'brrr',
	'cabs',
	'caca',
	'cade',
	'cads',
	'cafe',
	'caff',
	'cage',
	'carb',
	'card',
	'care',
	'carr',
	'cars',
	'cart',
	'casa',
	'case',
	'cast',
	'cate',
	'cats',
	'cave',
	'caws',
	'ceca',
	'cede',
	'cees',
	'cere',
	'cess',
	'cete',
	'crab',
	'crag',
	'craw',
	'crew',
	'czar',
	'dabs',
	'dace',
	'dada',
	'dads',
	'daff',
	'daft',
	'dags',
	'darb',
	'dare',
	'dart',
	'data',
	'date',
	'daws',
	'dawt',
	'daze',
	'dead',
	'deaf',
	'dear',
	'debs',
	'debt',
	'deed',
	'deer',
	'dees',
	'deet',
	'deft',
	'dere',
	'deva',
	'devs',
	'dews',
	'drab',
	'drag',
	'drat',
	'draw',
	'dree',
	'dreg',
	'drew',
	'ears',
	'ease',
	'east',
	'eats',
	'eave',
	'ebbs',
	'edge',
	'effs',
	'efts',
	'egad',
	'eger',
	'eggs',
	'eras',
	'ergs',
	'errs',
	'erst',
	'eses',
	'etas',
	'ever',
	'eves',
	'ewer',
	'ewes',
	'exec',
	'exes',
	'face',
	'fact',
	'fade',
	'fads',
	'fags',
	'fard',
	'fare',
	'fart',
	'fast',
	'fate',
	'fats',
	'fava',
	'fave',
	'faze',
	'fear',
	'feat',
	'feds',
	'feed',
	'fees',
	'feet',
	'fere',
	'fess',
	'feta',
	'fete',
	'fets',
	'frae',
	'frag',
	'frat',
	'free',
	'fret',
	'gabs',
	'gads',
	'gaed',
	'gaes',
	'gaff',
	'gaga',
	'gage',
	'gags',
	'garb',
	'gars',
	'gast',
	'gate',
	'gats',
	'gave',
	'gaze',
	'gear',
	'geds',
	'geed',
	'gees',
	'geez',
	'gest',
	'geta',
	'gets',
	'grab',
	'grad',
	'grat',
	'gree',
	'grew',
	'qats',
	'race',
	'rads',
	'raff',
	'raft',
	'raga',
	'rage',
	'rags',
	'rare',
	'rase',
	'rate',
	'rats',
	'rave',
	'raws',
	'raze',
	'razz',
	'read',
	'rear',
	'rebs',
	'recs',
	'redd',
	'rede',
	'reds',
	'reed',
	'reef',
	'rees',
	'refs',
	'reft',
	'regs',
	'rest',
	'rete',
	'rets',
	'revs',
	'sabe',
	'sabs',
	'sacs',
	'sade',
	'safe',
	'saga',
	'sage',
	'sags',
	'sard',
	'sass',
	'sate',
	'save',
	'saws',
	'scab',
	'scad',
	'scag',
	'scar',
	'scat',
	'sear',
	'seas',
	'seat',
	'secs',
	'sect',
	'seed',
	'seer',
	'sees',
	'segs',
	'sera',
	'sere',
	'serf',
	'sers',
	'seta',
	'sets',
	'sett',
	'sews',
	'stab',
	'stag',
	'star',
	'stat',
	'staw',
	'stet',
	'stew',
	'swab',
	'swag',
	'swat',
	'tabs',
	'tace',
	'tact',
	'tads',
	'tags',
	'tare',
	'tars',
	'tart',
	'tass',
	'tate',
	'tats',
	'tavs',
	'taws',
	'taxa',
	'tear',
	'teas',
	'teat',
	'teds',
	'teed',
	'tees',
	'teff',
	'tegs',
	'test',
	'tets',
	'tews',
	'text',
	'trad',
	'tree',
	'tref',
	'tret',
	'tsar',
	'twae',
	'twas',
	'twat',
	'twee',
	'tzar',
	'vacs',
	'vara',
	'vars',
	'vasa',
	'vase',
	'vast',
	'vats',
	'vavs',
	'vaws',
	'veer',
	'vees',
	'vera',
	'verb',
	'vert',
	'vest',
	'vets',
	'vext',
	'wabs',
	'wade',
	'wads',
	'waes',
	'waff',
	'waft',
	'wage',
	'wags',
	'ward',
	'ware',
	'wars',
	'wart',
	'wast',
	'wats',
	'watt',
	'wave',
	'waws',
	'wear',
	'webs',
	'weds',
	'weed',
	'weer',
	'wees',
	'weet',
	'weft',
	'were',
	'wert',
	'west',
	'wets',
	'zags',
	'zarf',
	'zeds',
	'zees',
	'zest',
	'zeta',
];

exports.keyboard_5LetterWords = [
	'abaca',
	'abaft',
	'abase',
	'abate',
	'abbas',
	'abbes',
	'abets',
	'acerb',
	'aceta',
	'acred',
	'acres',
	'acted',
	'adage',
	'addax',
	'added',
	'adder',
	'adzes',
	'aedes',
	'afars',
	'after',
	'agars',
	'agate',
	'agave',
	'agaze',
	'agers',
	'agger',
	'agree',
	'arced',
	'ardeb',
	'areae',
	'areas',
	'areca',
	'arete',
	'arras',
	'arses',
	'asses',
	'asset',
	'aster',
	'attar',
	'avast',
	'avers',
	'avert',
	'avgas',
	'award',
	'aware',
	'baaed',
	'babas',
	'babes',
	'bacca',
	'badge',
	'baffs',
	'barbe',
	'barbs',
	'barde',
	'bards',
	'bared',
	'barer',
	'bares',
	'barfs',
	'barge',
	'barre',
	'based',
	'baser',
	'bases',
	'baste',
	'basts',
	'bated',
	'bates',
	'batts',
	'bawds',
	'bazar',
	'beads',
	'beard',
	'bears',
	'beast',
	'beats',
	'bedew',
	'beefs',
	'beers',
	'beets',
	'begat',
	'beget',
	'beret',
	'bergs',
	'beset',
	'bests',
	'betas',
	'betta',
	'brace',
	'bract',
	'brads',
	'braes',
	'brags',
	'brass',
	'brats',
	'brava',
	'brave',
	'braws',
	'braza',
	'braze',
	'bread',
	'brede',
	'breed',
	'brees',
	'breve',
	'brews',
	'caber',
	'cacas',
	'cades',
	'cadet',
	'cadge',
	'cadre',
	'caeca',
	'cafes',
	'caffs',
	'caged',
	'cager',
	'cages',
	'carat',
	'carbs',
	'cards',
	'cared',
	'carer',
	'cares',
	'caret',
	'carex',
	'carrs',
	'carse',
	'carte',
	'carts',
	'carve',
	'casas',
	'cased',
	'cases',
	'caste',
	'casts',
	'cater',
	'cates',
	'caved',
	'caver',
	'caves',
	'cawed',
	'cease',
	'cedar',
	'ceded',
	'ceder',
	'cedes',
	'cered',
	'ceres',
	'cesta',
	'cetes',
	'crabs',
	'craft',
	'crags',
	'crass',
	'crate',
	'crave',
	'craws',
	'craze',
	'creed',
	'cress',
	'crest',
	'crews',
	'czars',
	'daces',
	'dadas',
	'daffs',
	'dagga',
	'darbs',
	'dared',
	'darer',
	'dares',
	'darts',
	'dated',
	'dater',
	'dates',
	'dawed',
	'dawts',
	'dazed',
	'dazes',
	'deads',
	'dears',
	'deave',
	'debar',
	'debts',
	'decaf',
	'deeds',
	'deers',
	'deets',
	'defat',
	'defer',
	'degas',
	'derat',
	'deter',
	'devas',
	'dewar',
	'dewax',
	'dewed',
	'dexes',
	'drabs',
	'draff',
	'draft',
	'drags',
	'drats',
	'drave',
	'draws',
	'dread',
	'drear',
	'dreed',
	'drees',
	'dregs',
	'dress',
	'drest',
	'dwarf',
	'dweeb',
	'eager',
	'eagre',
	'eared',
	'eased',
	'eases',
	'easts',
	'eater',
	'eaved',
	'eaves',
	'ebbed',
	'ebbet',
	'edged',
	'edger',
	'edges',
	'egads',
	'egers',
	'egest',
	'eggar',
	'egged',
	'egger',
	'egret',
	'erase',
	'erect',
	'erred',
	'erses',
	'escar',
	'esses',
	'ester',
	'etwee',
	'evade',
	'evert',
	'ewers',
	'exact',
	'execs',
	'exert',
	'extra',
	'faced',
	'facer',
	'faces',
	'facet',
	'facts',
	'faded',
	'fader',
	'fades',
	'fadge',
	'farad',
	'farce',
	'fards',
	'fared',
	'farer',
	'fares',
	'farts',
	'fasts',
	'fated',
	'fates',
	'fatwa',
	'favas',
	'faves',
	'faxed',
	'faxes',
	'fazed',
	'fazes',
	'fears',
	'fease',
	'feast',
	'feats',
	'feaze',
	'feces',
	'feeds',
	'feeze',
	'feres',
	'fesse',
	'fetas',
	'feted',
	'fetes',
	'fever',
	'fewer',
	'fezes',
	'frags',
	'frass',
	'frats',
	'freed',
	'freer',
	'frees',
	'frere',
	'frets',
	'gaffe',
	'gaffs',
	'gaged',
	'gager',
	'gages',
	'garbs',
	'gases',
	'gasts',
	'gated',
	'gates',
	'gazar',
	'gazed',
	'gazer',
	'gazes',
	'gears',
	'geese',
	'geest',
	'geste',
	'gests',
	'getas',
	'grabs',
	'grace',
	'grade',
	'grads',
	'graft',
	'grass',
	'grate',
	'grave',
	'graze',
	'great',
	'grebe',
	'greed',
	'grees',
	'greet',
	'rabat',
	'raced',
	'racer',
	'races',
	'radar',
	'raffs',
	'rafts',
	'ragas',
	'raged',
	'ragee',
	'rages',
	'rared',
	'rarer',
	'rares',
	'rased',
	'raser',
	'rases',
	'rated',
	'rater',
	'rates',
	'raved',
	'raver',
	'raves',
	'rawer',
	'raxed',
	'raxes',
	'razed',
	'razee',
	'razer',
	'razes',
	'react',
	'readd',
	'reads',
	'rears',
	'reata',
	'reave',
	'rebar',
	'rebbe',
	'rebec',
	'recce',
	'recta',
	'redds',
	'reded',
	'redes',
	'reeds',
	'reefs',
	'reest',
	'reeve',
	'refed',
	'refer',
	'reges',
	'resaw',
	'resee',
	'reset',
	'resew',
	'rests',
	'retag',
	'retax',
	'revet',
	'rewax',
	'rewed',
	'rewet',
	'rexes',
	'sabed',
	'saber',
	'sabes',
	'sabra',
	'sabre',
	'sacra',
	'sades',
	'safer',
	'safes',
	'sagas',
	'sager',
	'sages',
	'sards',
	'saree',
	'sarge',
	'sated',
	'sates',
	'saved',
	'saver',
	'saves',
	'sawed',
	'sawer',
	'saxes',
	'scabs',
	'scads',
	'scags',
	'scare',
	'scarf',
	'scars',
	'scart',
	'scats',
	'scatt',
	'scrag',
	'scree',
	'screw',
	'sears',
	'seats',
	'sects',
	'seder',
	'sedge',
	'seeds',
	'seers',
	'serac',
	'sered',
	'serer',
	'seres',
	'serfs',
	'serge',
	'serve',
	'setae',
	'setts',
	'sever',
	'sewar',
	'sewed',
	'sewer',
	'stabs',
	'stade',
	'staff',
	'stage',
	'stags',
	'stare',
	'stars',
	'start',
	'state',
	'stats',
	'stave',
	'stead',
	'steed',
	'steer',
	'stere',
	'stets',
	'stews',
	'straw',
	'strew',
	'swabs',
	'swage',
	'swags',
	'sward',
	'sware',
	'swarf',
	'swart',
	'swats',
	'swear',
	'sweat',
	'swede',
	'sweer',
	'sweet',
	'taber',
	'tabes',
	'taces',
	'tacet',
	'tacte',
	'tacts',
	'tared',
	'tares',
	'targe',
	'tarre',
	'tarts',
	'tasse',
	'taste',
	'tatar',
	'tater',
	'tates',
	'tawed',
	'tawer',
	'tawse',
	'taxed',
	'taxer',
	'taxes',
	'tazza',
	'tazze',
	'tears',
	'tease',
	'teats',
	'tecta',
	'teffs',
	'terce',
	'terga',
	'terra',
	'terse',
	'testa',
	'tests',
	'tetra',
	'tewed',
	'texas',
	'texts',
	'trace',
	'tract',
	'trade',
	'trass',
	'trave',
	'tread',
	'treat',
	'treed',
	'trees',
	'tress',
	'trets',
	'trews',
	'tsade',
	'tsars',
	'twaes',
	'twats',
	'tweed',
	'tweet',
	'tzars',
	'varas',
	'varve',
	'vases',
	'vasts',
	'veers',
	'verbs',
	'verge',
	'verse',
	'verst',
	'verts',
	'verve',
	'vesta',
	'vests',
	'vexed',
	'vexer',
	'vexes',
	'waded',
	'wader',
	'wades',
	'wafer',
	'waffs',
	'wafts',
	'waged',
	'wager',
	'wages',
	'wards',
	'wared',
	'wares',
	'warts',
	'waste',
	'wasts',
	'water',
	'watts',
	'waved',
	'waver',
	'waves',
	'waxed',
	'waxer',
	'waxes',
	'wears',
	'weave',
	'weber',
	'wedge',
	'weeds',
	'weest',
	'weets',
	'wefts',
	'wests',
	'wrest',
	'xebec',
	'zarfs',
	'zaxes',
	'zebec',
	'zebra',
	'zests',
	'zetas',
];

exports.keyboard_6LetterWords = [
	'abacas',
	'abased',
	'abaser',
	'abases',
	'abated',
	'abater',
	'abates',
	'abbess',
	'abrade',
	'abwatt',
	'accede',
	'access',
	'adages',
	'adders',
	'advect',
	'adverb',
	'advert',
	'aerate',
	'afeard',
	'affect',
	'afreet',
	'afters',
	'agates',
	'agaves',
	'aggers',
	'agrafe',
	'agreed',
	'agrees',
	'arcade',
	'ardebs',
	'arecas',
	'aretes',
	'arrear',
	'arrest',
	'assert',
	'assess',
	'assets',
	'asters',
	'attars',
	'attest',
	'avatar',
	'averse',
	'averts',
	'awards',
	'axseed',
	'baases',
	'baccae',
	'badass',
	'badder',
	'badged',
	'badger',
	'badges',
	'baffed',
	'bagass',
	'bagged',
	'bagger',
	'barbed',
	'barber',
	'barbes',
	'barbet',
	'barded',
	'bardes',
	'barege',
	'barest',
	'barfed',
	'barged',
	'bargee',
	'barges',
	'barred',
	'barres',
	'barret',
	'barter',
	'basest',
	'basses',
	'basset',
	'basted',
	'baster',
	'bastes',
	'batted',
	'batter',
	'bawbee',
	'bazaar',
	'bazars',
	'beaded',
	'beards',
	'bearer',
	'beasts',
	'beater',
	'beaver',
	'bedded',
	'bedder',
	'bedews',
	'beebee',
	'beefed',
	'beeves',
	'beezer',
	'befret',
	'begaze',
	'begets',
	'beggar',
	'begged',
	'berate',
	'bereft',
	'berets',
	'besets',
	'bested',
	'bettas',
	'betted',
	'better',
	'beware',
	'bezazz',
	'braced',
	'bracer',
	'braces',
	'bracts',
	'bravas',
	'braved',
	'braver',
	'braves',
	'brawer',
	'brazas',
	'brazed',
	'brazer',
	'brazes',
	'breads',
	'breast',
	'bredes',
	'breeds',
	'breeze',
	'breves',
	'brevet',
	'brewed',
	'brewer',
	'cabbed',
	'cabers',
	'cadets',
	'cadged',
	'cadger',
	'cadges',
	'cadres',
	'caesar',
	'cagers',
	'carafe',
	'carate',
	'carats',
	'carded',
	'carder',
	'career',
	'carers',
	'caress',
	'carets',
	'carses',
	'carted',
	'carter',
	'cartes',
	'carved',
	'carver',
	'carves',
	'casaba',
	'casava',
	'caster',
	'castes',
	'caters',
	'catted',
	'caveat',
	'cavers',
	'ceased',
	'ceases',
	'cedars',
	'ceders',
	'cerate',
	'certes',
	'cessed',
	'cesses',
	'cestas',
	'crafts',
	'crases',
	'crated',
	'crater',
	'crates',
	'cravat',
	'craved',
	'craver',
	'craves',
	'crazed',
	'crazes',
	'crease',
	'create',
	'creeds',
	'creese',
	'crests',
	'crewed',
	'dabbed',
	'dabber',
	'daffed',
	'dafter',
	'daggas',
	'dagger',
	'darers',
	'darted',
	'darter',
	'daters',
	'dawted',
	'deader',
	'deafer',
	'dearer',
	'deaved',
	'deaves',
	'debars',
	'debase',
	'debate',
	'decade',
	'decafs',
	'decare',
	'decree',
	'deeded',
	'deface',
	'defats',
	'defeat',
	'defect',
	'defers',
	'defter',
	'degage',
	'degree',
	'derate',
	'derats',
	'desert',
	'detect',
	'deters',
	'detest',
	'devest',
	'dewars',
	'dexter',
	'draffs',
	'drafts',
	'dragee',
	'drawee',
	'drawer',
	'dreads',
	'drears',
	'dredge',
	'dwarfs',
	'dweebs',
	'eagers',
	'eagres',
	'earwax',
	'easter',
	'eaters',
	'ebbets',
	'ecarte',
	'edgers',
	'efface',
	'effect',
	'effete',
	'egesta',
	'egests',
	'eggars',
	'eggers',
	'egress',
	'egrets',
	'erased',
	'eraser',
	'erases',
	'erects',
	'ergate',
	'errata',
	'ersatz',
	'escars',
	'estate',
	'esters',
	'etwees',
	'evaded',
	'evader',
	'evades',
	'everts',
	'exacta',
	'exacts',
	'exceed',
	'excess',
	'exedra',
	'exerts',
	'exsect',
	'exsert',
	'extras',
	'facade',
	'facers',
	'facete',
	'facets',
	'faders',
	'fadged',
	'fadges',
	'faeces',
	'fagged',
	'farads',
	'farced',
	'farcer',
	'farces',
	'farded',
	'farers',
	'farted',
	'fasces',
	'fasted',
	'faster',
	'fatted',
	'fatter',
	'fatwas',
	'feared',
	'fearer',
	'feased',
	'feases',
	'feasts',
	'feater',
	'feazed',
	'feazes',
	'feeder',
	'feezed',
	'feezes',
	'ferret',
	'fessed',
	'fesses',
	'fester',
	'fetted',
	'fetter',
	'fevers',
	'fewest',
	'fezzed',
	'fezzes',
	'fracas',
	'frater',
	'freers',
	'freest',
	'freeze',
	'freres',
	'gabbed',
	'gabber',
	'gadded',
	'gadder',
	'gadget',
	'gaffed',
	'gaffer',
	'gaffes',
	'gagers',
	'gagged',
	'gagger',
	'garage',
	'garbed',
	'garget',
	'garred',
	'garret',
	'garter',
	'gasbag',
	'gassed',
	'gasser',
	'gasses',
	'gasted',
	'gaster',
	'gavage',
	'gazars',
	'gazers',
	'geared',
	'geegaw',
	'geests',
	'geezer',
	'gestes',
	'getter',
	'gewgaw',
	'graced',
	'graces',
	'graded',
	'grader',
	'grades',
	'grafts',
	'grated',
	'grater',
	'grates',
	'graved',
	'graver',
	'graves',
	'grazed',
	'grazer',
	'grazes',
	'grease',
	'greats',
	'greave',
	'grebes',
	'greeds',
	'greets',
	'rabats',
	'rabbet',
	'racers',
	'radars',
	'radded',
	'rafted',
	'rafter',
	'ragbag',
	'ragees',
	'ragged',
	'raggee',
	'ragtag',
	'rarest',
	'rasers',
	'raster',
	'ratbag',
	'raters',
	'ratted',
	'ratter',
	'ravage',
	'ravers',
	'rawest',
	'razeed',
	'razees',
	'razers',
	'razzed',
	'razzes',
	'reacts',
	'readds',
	'reader',
	'reared',
	'rearer',
	'reatas',
	'reaved',
	'reaver',
	'reaves',
	'rebars',
	'rebate',
	'rebbes',
	'rebecs',
	'rebred',
	'recast',
	'recces',
	'recede',
	'recess',
	'redact',
	'redate',
	'redded',
	'redder',
	'redear',
	'redraw',
	'redrew',
	'reeded',
	'reefed',
	'reefer',
	'reests',
	'reeved',
	'reeves',
	'reface',
	'refect',
	'refeed',
	'refers',
	'reffed',
	'regard',
	'regave',
	'regear',
	'reggae',
	'regret',
	'regrew',
	'reread',
	'resaws',
	'reseat',
	'resect',
	'reseda',
	'reseed',
	'resees',
	'resets',
	'resews',
	'rested',
	'rester',
	'retags',
	'retard',
	'retear',
	'retest',
	'retted',
	'reverb',
	'revere',
	'revers',
	'revert',
	'revest',
	'revets',
	'revved',
	'reward',
	'reweds',
	'rewets',
	'sabbat',
	'sabbed',
	'sabers',
	'sabras',
	'sabred',
	'sabres',
	'sacred',
	'sadder',
	'safest',
	'sagest',
	'saggar',
	'sagged',
	'sagger',
	'sardar',
	'sarees',
	'sarges',
	'sarsar',
	'sassed',
	'sasses',
	'satara',
	'savage',
	'savate',
	'savers',
	'sawers',
	'scarab',
	'scarce',
	'scared',
	'scarer',
	'scares',
	'scarfs',
	'scarts',
	'scatts',
	'scrags',
	'screed',
	'screes',
	'screws',
	'seabag',
	'seabed',
	'seared',
	'searer',
	'seated',
	'seater',
	'secede',
	'secret',
	'sedate',
	'seders',
	'sedges',
	'seeded',
	'seeder',
	'seesaw',
	'seggar',
	'seracs',
	'serdab',
	'serest',
	'serges',
	'served',
	'server',
	'serves',
	'sestet',
	'settee',
	'setter',
	'severe',
	'severs',
	'sewage',
	'sewars',
	'sewers',
	'sextet',
	'stades',
	'staffs',
	'staged',
	'stager',
	'stages',
	'stared',
	'starer',
	'stares',
	'starts',
	'starve',
	'stases',
	'stated',
	'stater',
	'states',
	'staved',
	'staves',
	'steads',
	'steeds',
	'steers',
	'steeve',
	'steres',
	'stewed',
	'strafe',
	'strass',
	'strata',
	'straws',
	'street',
	'stress',
	'strews',
	'swaged',
	'swager',
	'swages',
	'swards',
	'swarfs',
	'swears',
	'sweats',
	'swedes',
	'sweets',
	'swerve',
	'tabard',
	'tabbed',
	'tabers',
	'tagged',
	'tagger',
	'tagrag',
	'targes',
	'target',
	'tarred',
	'tarres',
	'tartar',
	'tarted',
	'tarter',
	'tasses',
	'tasset',
	'tasted',
	'taster',
	'tastes',
	'tatars',
	'taters',
	'tatted',
	'tatter',
	'tawers',
	'tawsed',
	'tawses',
	'taxers',
	'tazzas',
	'teared',
	'tearer',
	'teased',
	'teaser',
	'teases',
	'teated',
	'tedded',
	'tedder',
	'teeter',
	'terces',
	'tercet',
	'terete',
	'terrae',
	'terras',
	'terret',
	'terser',
	'testae',
	'tested',
	'testee',
	'tester',
	'testes',
	'tetrad',
	'tetras',
	'tetter',
	'traced',
	'tracer',
	'traces',
	'tracts',
	'traded',
	'trader',
	'trades',
	'traves',
	'treads',
	'treats',
	'trevet',
	'tsades',
	'tsetse',
	'tweeds',
	'tweets',
	'tweeze',
	'tzetze',
	'vacate',
	'varved',
	'varves',
	'vaster',
	'vatted',
	'vaward',
	'veered',
	'vegete',
	'verged',
	'verger',
	'verges',
	'versed',
	'verser',
	'verses',
	'verset',
	'verste',
	'versts',
	'vertex',
	'verves',
	'vervet',
	'vestas',
	'vested',
	'vestee',
	'vetted',
	'vexers',
	'wadded',
	'wadder',
	'waders',
	'wadset',
	'wafers',
	'waffed',
	'wafted',
	'wafter',
	'wagers',
	'wagged',
	'wagger',
	'warded',
	'warder',
	'warred',
	'warsaw',
	'warted',
	'wasted',
	'waster',
	'wastes',
	'waters',
	'watter',
	'wavers',
	'waxers',
	'wearer',
	'weaved',
	'weaver',
	'weaves',
	'webbed',
	'webers',
	'webfed',
	'wedded',
	'wedder',
	'wedged',
	'wedges',
	'weeded',
	'weeder',
	'weeted',
	'weever',
	'weewee',
	'wester',
	'wetted',
	'wetter',
	'wrasse',
	'wrests',
	'xebecs',
	'zaffar',
	'zaffer',
	'zaffre',
	'zagged',
	'zareba',
	'zebecs',
	'zebras',
	'zested',
	'zester',
];

exports.keyboard_7LetterWords = [
	'abasers',
	'abaters',
	'abetted',
	'abetter',
	'abfarad',
	'abraded',
	'abrader',
	'abrades',
	'abreact',
	'abreast',
	'abscess',
	'abwatts',
	'acceded',
	'acceder',
	'accedes',
	'accrete',
	'acerate',
	'acerber',
	'acetate',
	'acreage',
	'actress',
	'addaxes',
	'address',
	'addrest',
	'advects',
	'adverbs',
	'adverse',
	'adverts',
	'aerated',
	'aerates',
	'afeared',
	'affects',
	'afreets',
	'aggrade',
	'aggress',
	'agrafes',
	'agraffe',
	'arcaded',
	'arcades',
	'arrased',
	'arrears',
	'arrests',
	'asceses',
	'asserts',
	'asswage',
	'attests',
	'attract',
	'avatars',
	'average',
	'averred',
	'averted',
	'avgases',
	'awarded',
	'awardee',
	'awarder',
	'axseeds',
	'baccara',
	'baccate',
	'baddest',
	'badgers',
	'bagasse',
	'baggage',
	'baggers',
	'barbate',
	'barbers',
	'barbets',
	'bareges',
	'bargees',
	'barrage',
	'barrets',
	'barters',
	'barware',
	'bassets',
	'bassett',
	'bastard',
	'basters',
	'batters',
	'bawbees',
	'bazaars',
	'bearcat',
	'bearded',
	'bearers',
	'beaters',
	'beavers',
	'bedders',
	'bedewed',
	'bedfast',
	'bedward',
	'bedwarf',
	'beebees',
	'beeswax',
	'beezers',
	'befrets',
	'begazed',
	'begazes',
	'beggars',
	'berated',
	'berates',
	'bereave',
	'beretta',
	'bergere',
	'bestead',
	'bestrew',
	'betaxed',
	'betters',
	'bewared',
	'bewares',
	'bracers',
	'bracted',
	'bradded',
	'bragged',
	'bragger',
	'brassed',
	'brasses',
	'bravers',
	'bravest',
	'brawest',
	'brazers',
	'breaded',
	'breasts',
	'breeder',
	'breezed',
	'breezes',
	'brevets',
	'brewage',
	'brewers',
	'cabaret',
	'cabbage',
	'cadaver',
	'cadgers',
	'caesars',
	'carafes',
	'carates',
	'carcase',
	'carcass',
	'carders',
	'careers',
	'carfare',
	'cartage',
	'carters',
	'carvers',
	'casabas',
	'casavas',
	'cascade',
	'cascara',
	'casease',
	'caseate',
	'casette',
	'cassaba',
	'cassata',
	'cassava',
	'casters',
	'catawba',
	'catered',
	'caterer',
	'catface',
	'caveats',
	'cerated',
	'cerates',
	'cerebra',
	'crabbed',
	'crabber',
	'crafted',
	'cragged',
	'crasser',
	'craters',
	'cravats',
	'cravers',
	'crawdad',
	'creased',
	'creaser',
	'creases',
	'created',
	'creates',
	'creeses',
	'cresses',
	'cresset',
	'crested',
	'czardas',
	'dabbers',
	'dabster',
	'daftest',
	'daggers',
	'darters',
	'dastard',
	'deadest',
	'deafest',
	'dearest',
	'debased',
	'debaser',
	'debases',
	'debated',
	'debater',
	'debates',
	'decades',
	'decares',
	'decease',
	'decreed',
	'decreer',
	'decrees',
	'defaced',
	'defacer',
	'defaces',
	'defeats',
	'defects',
	'deftest',
	'degases',
	'degrade',
	'degreed',
	'degrees',
	'derated',
	'derates',
	'deserts',
	'deserve',
	'dessert',
	'detects',
	'deterge',
	'detests',
	'detract',
	'devests',
	'dewater',
	'dewaxed',
	'dewaxes',
	'drabbed',
	'drabber',
	'drabbet',
	'drafted',
	'draftee',
	'drafter',
	'dragees',
	'dragged',
	'dragger',
	'dratted',
	'drawbar',
	'drawees',
	'drawers',
	'dreaded',
	'dredged',
	'dredger',
	'dredges',
	'dressed',
	'dresser',
	'dresses',
	'dwarfed',
	'dwarfer',
	'dwarves',
	'eagerer',
	'easters',
	'ecartes',
	'ectases',
	'effaced',
	'effacer',
	'effaces',
	'effects',
	'egested',
	'erasers',
	'erected',
	'erecter',
	'ergates',
	'erratas',
	'estated',
	'estates',
	'estreat',
	'etagere',
	'evaders',
	'everted',
	'exactas',
	'exacted',
	'exacter',
	'exceeds',
	'excreta',
	'excrete',
	'exedrae',
	'exegete',
	'exerted',
	'exsects',
	'exserts',
	'extract',
	'facades',
	'faceted',
	'farcers',
	'fastest',
	'fattest',
	'fearers',
	'feasted',
	'feaster',
	'featest',
	'feedbag',
	'feeders',
	'ferrate',
	'ferrets',
	'festers',
	'fetters',
	'fevered',
	'fracted',
	'fragged',
	'frasses',
	'fraters',
	'freebee',
	'freezer',
	'freezes',
	'fretsaw',
	'fretted',
	'fretter',
	'gabbard',
	'gabbart',
	'gabbers',
	'gabfest',
	'gadders',
	'gadgets',
	'gaffers',
	'gaggers',
	'gagster',
	'garaged',
	'garages',
	'garbage',
	'gargets',
	'garrets',
	'garters',
	'gasbags',
	'gassers',
	'gasters',
	'gastrea',
	'gavages',
	'gazette',
	'geegaws',
	'geezers',
	'gerbera',
	'gestate',
	'getters',
	'gewgaws',
	'grabbed',
	'grabber',
	'gradate',
	'graders',
	'grafted',
	'grafter',
	'grassed',
	'grasses',
	'graters',
	'gravers',
	'gravest',
	'grazers',
	'greased',
	'greaser',
	'greases',
	'greater',
	'greaved',
	'greaves',
	'greeted',
	'greeter',
	'rabbets',
	'rafters',
	'ragbags',
	'raggees',
	'ragtags',
	'ragweed',
	'rasters',
	'ratafee',
	'ratatat',
	'ratbags',
	'ratters',
	'ravaged',
	'ravager',
	'ravages',
	'reacted',
	'readded',
	'readers',
	'rearers',
	'reavers',
	'rebated',
	'rebater',
	'rebates',
	'rebreed',
	'recasts',
	'receded',
	'recedes',
	'recrate',
	'redacts',
	'redated',
	'redates',
	'redders',
	'reddest',
	'redears',
	'redraft',
	'redraws',
	'redress',
	'redware',
	'reefers',
	'reerect',
	'reested',
	'refaced',
	'refaces',
	'refects',
	'refeeds',
	'referee',
	'refract',
	'regards',
	'regatta',
	'regears',
	'reggaes',
	'regrade',
	'regraft',
	'regrate',
	'regreet',
	'regress',
	'regrets',
	'rereads',
	'resawed',
	'reseats',
	'resects',
	'resedas',
	'reseeds',
	'reserve',
	'resewed',
	'restaff',
	'restage',
	'restart',
	'restate',
	'resters',
	'retards',
	'retaste',
	'retaxed',
	'retaxes',
	'retears',
	'retests',
	'retrace',
	'retract',
	'retread',
	'retreat',
	'reverbs',
	'revered',
	'reverer',
	'reveres',
	'reverse',
	'reverts',
	'revests',
	'rewards',
	'rewaxed',
	'rewaxes',
	'reweave',
	'sabbats',
	'sabered',
	'saccade',
	'saccate',
	'saddest',
	'saggard',
	'saggars',
	'saggers',
	'sardars',
	'sarsars',
	'sataras',
	'savaged',
	'savager',
	'savages',
	'savates',
	'scabbed',
	'scarabs',
	'scarcer',
	'scarers',
	'scarfed',
	'scarred',
	'scarted',
	'scarves',
	'scatted',
	'scatter',
	'screeds',
	'screwed',
	'screwer',
	'seabags',
	'seabeds',
	'searest',
	'seaters',
	'seaward',
	'seaware',
	'seaweed',
	'seceded',
	'seceder',
	'secedes',
	'secrete',
	'secrets',
	'sedated',
	'sedater',
	'sedates',
	'seedbed',
	'seeders',
	'seeress',
	'seesaws',
	'seggars',
	'serdabs',
	'serfage',
	'serrate',
	'servers',
	'sestets',
	'settees',
	'setters',
	'severed',
	'severer',
	'sewages',
	'sewered',
	'sextets',
	'stabbed',
	'stabber',
	'stactes',
	'staffed',
	'staffer',
	'stagers',
	'stagged',
	'stagger',
	'starers',
	'starets',
	'starred',
	'started',
	'starter',
	'starved',
	'starver',
	'starves',
	'staters',
	'steaded',
	'steered',
	'steerer',
	'steeved',
	'steeves',
	'stetted',
	'steward',
	'strafed',
	'strafer',
	'strafes',
	'stratas',
	'strawed',
	'streets',
	'stretta',
	'strette',
	'strewed',
	'strewer',
	'swabbed',
	'swabber',
	'swagers',
	'swagged',
	'swagger',
	'swarded',
	'swatted',
	'swatter',
	'swearer',
	'sweated',
	'sweater',
	'sweeter',
	'swerved',
	'swerver',
	'swerves',
	'tabards',
	'tabaret',
	'tabered',
	'taffeta',
	'taggers',
	'tagrags',
	'targets',
	'tartars',
	'tartest',
	'tarweed',
	'tassets',
	'tasters',
	'tatters',
	'teacart',
	'tearers',
	'teargas',
	'teasers',
	'teaware',
	'tedders',
	'teeters',
	'tercets',
	'terrace',
	'terrets',
	'tersest',
	'tessera',
	'testate',
	'testees',
	'testers',
	'tetrads',
	'tetters',
	'texases',
	'tracers',
	'traders',
	'trasses',
	'treaded',
	'treader',
	'treated',
	'treater',
	'tressed',
	'tresses',
	'trevets',
	'tsetses',
	'tweeted',
	'tweeter',
	'tweezed',
	'tweezer',
	'tweezes',
	'tzetzes',
	'vacated',
	'vacates',
	'vastest',
	'vawards',
	'vedette',
	'vergers',
	'versers',
	'versets',
	'verstes',
	'vervets',
	'vestees',
	'wadders',
	'wadsets',
	'wafered',
	'waftage',
	'wafters',
	'wagered',
	'wagerer',
	'waggers',
	'warders',
	'warfare',
	'warsaws',
	'wastage',
	'wasters',
	'watered',
	'waterer',
	'wattage',
	'wattest',
	'wavered',
	'waverer',
	'waxweed',
	'wearers',
	'weavers',
	'webfeet',
	'webster',
	'wedders',
	'weeders',
	'weevers',
	'weeweed',
	'weewees',
	'westers',
	'wetters',
	'wettest',
	'wrasses',
	'wrested',
	'wrester',
	'zaffars',
	'zaffers',
	'zaffres',
	'zarebas',
	'zareeba',
	'zebrass',
	'zesters',
];

exports.keyboard_8LetterWords = [
	'abbesses',
	'abetters',
	'abfarads',
	'abraders',
	'abreacts',
	'absterge',
	'abstract',
	'acceders',
	'accessed',
	'accesses',
	'accreted',
	'accretes',
	'acerated',
	'acerbate',
	'acerbest',
	'acervate',
	'acetated',
	'acetates',
	'acreages',
	'advected',
	'adverted',
	'affected',
	'affecter',
	'aftertax',
	'aggraded',
	'aggrades',
	'agraffes',
	'arrested',
	'arrestee',
	'arrester',
	'artefact',
	'asserted',
	'asserter',
	'assessed',
	'assesses',
	'asswaged',
	'asswages',
	'attested',
	'attester',
	'attracts',
	'avadavat',
	'averaged',
	'averages',
	'avgasses',
	'awardees',
	'awarders',
	'baccaras',
	'baccarat',
	'baccated',
	'badassed',
	'badasses',
	'badgered',
	'bagasses',
	'baggages',
	'barbered',
	'barbette',
	'barraged',
	'barrages',
	'barrater',
	'barrette',
	'bartered',
	'barterer',
	'barwares',
	'basseted',
	'bassetts',
	'bastards',
	'battered',
	'bearcats',
	'beavered',
	'bedstead',
	'bedstraw',
	'bedwards',
	'bedwarfs',
	'beebread',
	'begetter',
	'beggared',
	'bereaved',
	'bereaver',
	'bereaves',
	'berettas',
	'bergeres',
	'berretta',
	'besetter',
	'besteads',
	'bestrews',
	'betatter',
	'bettered',
	'beverage',
	'bezazzes',
	'braggart',
	'braggers',
	'braggest',
	'brassage',
	'brassard',
	'brassart',
	'breasted',
	'breeders',
	'breveted',
	'brewages',
	'cabarets',
	'cabbaged',
	'cabbages',
	'cabresta',
	'cabretta',
	'cadaster',
	'cadastre',
	'cadavers',
	'caracara',
	'carcases',
	'cardcase',
	'careered',
	'careerer',
	'carefree',
	'caressed',
	'caresser',
	'caresses',
	'carfares',
	'cartages',
	'cascaded',
	'cascades',
	'cascaras',
	'caseases',
	'caseated',
	'caseates',
	'casettes',
	'cassabas',
	'cassatas',
	'cassavas',
	'cassette',
	'castrate',
	'cataract',
	'catawbas',
	'caterers',
	'cateress',
	'catfaces',
	'caveated',
	'cerastes',
	'crabbers',
	'crassest',
	'cratered',
	'crawdads',
	'creasers',
	'cressets',
	'crevasse',
	'dabsters',
	'daggered',
	'dastards',
	'database',
	'deadbeat',
	'deaerate',
	'debarred',
	'debasers',
	'debaters',
	'deceased',
	'deceases',
	'decrease',
	'decreers',
	'deerweed',
	'defacers',
	'defatted',
	'defeated',
	'defeater',
	'defecate',
	'defected',
	'deferred',
	'deferrer',
	'degassed',
	'degasser',
	'degasses',
	'degraded',
	'degrader',
	'degrades',
	'degrease',
	'deratted',
	'deserted',
	'deserter',
	'deserved',
	'deserver',
	'deserves',
	'desserts',
	'detected',
	'detecter',
	'deterged',
	'deterger',
	'deterges',
	'deterred',
	'deterrer',
	'detested',
	'detester',
	'detracts',
	'devested',
	'dewaters',
	'drabbest',
	'drabbets',
	'draftees',
	'drafters',
	'draggers',
	'dragster',
	'drawbars',
	'dredgers',
	'dressage',
	'dressers',
	'dwarfest',
	'eagerest',
	'earwaxes',
	'eastward',
	'effacers',
	'effected',
	'effecter',
	'egressed',
	'egresses',
	'erecters',
	'ersatzes',
	'esterase',
	'estreats',
	'etageres',
	'etcetera',
	'exacters',
	'exactest',
	'excavate',
	'exceeded',
	'exceeder',
	'excessed',
	'excesses',
	'excreted',
	'excreter',
	'excretes',
	'execrate',
	'exegeses',
	'exegetes',
	'exsected',
	'exserted',
	'extracts',
	'facetted',
	'feasters',
	'federate',
	'feedbags',
	'ferrates',
	'ferreted',
	'ferreter',
	'festered',
	'fettered',
	'fetterer',
	'feverfew',
	'fracases',
	'freebase',
	'freebees',
	'freezers',
	'fretsaws',
	'fretters',
	'gabbards',
	'gabbarts',
	'gabfests',
	'gagsters',
	'garbages',
	'gartered',
	'gastraea',
	'gastreas',
	'gazetted',
	'gazettes',
	'gearcase',
	'gerberas',
	'gestated',
	'gestates',
	'gettered',
	'grabbers',
	'gradated',
	'gradates',
	'graftage',
	'grafters',
	'greasers',
	'greatest',
	'greegree',
	'greeters',
	'rabbeted',
	'radwaste',
	'raftered',
	'raggeder',
	'ragweeds',
	'ratafees',
	'ratatats',
	'ravagers',
	'reaccede',
	'rearrest',
	'rearward',
	'reassert',
	'reassess',
	'rebaters',
	'rebreeds',
	'recessed',
	'recesses',
	'recrated',
	'recrates',
	'recreate',
	'redacted',
	'redefeat',
	'redefect',
	'redrafts',
	'redrawer',
	'redstart',
	'redwares',
	'reerects',
	'refected',
	'refereed',
	'referees',
	'referred',
	'referrer',
	'refracts',
	'refreeze',
	'regarded',
	'regattas',
	'regeared',
	'regraded',
	'regrades',
	'regrafts',
	'regrated',
	'regrates',
	'regreets',
	'rereward',
	'reseated',
	'resected',
	'reseeded',
	'reserved',
	'reserver',
	'reserves',
	'resetter',
	'restaffs',
	'restaged',
	'restages',
	'restarts',
	'restated',
	'restates',
	'restress',
	'retagged',
	'retarded',
	'retarder',
	'retarget',
	'retasted',
	'retastes',
	'retested',
	'retraced',
	'retraces',
	'retracts',
	'retreads',
	'retreats',
	'reverbed',
	'reverers',
	'reversed',
	'reverser',
	'reverses',
	'reverted',
	'reverter',
	'revested',
	'revetted',
	'rewarded',
	'rewarder',
	'reweaved',
	'reweaves',
	'rewedded',
	'rewetted',
	'saccades',
	'saggards',
	'saggared',
	'saggered',
	'savagest',
	'scabbard',
	'scarcest',
	'scatters',
	'scragged',
	'screeded',
	'screwers',
	'seacraft',
	'seafarer',
	'seawards',
	'seawares',
	'seawater',
	'seaweeds',
	'seceders',
	'secreted',
	'secreter',
	'secretes',
	'sedatest',
	'seedbeds',
	'seedcase',
	'seesawed',
	'serfages',
	'serrated',
	'serrates',
	'sesterce',
	'setscrew',
	'severest',
	'sewerage',
	'sextette',
	'stabbers',
	'staffers',
	'staggard',
	'staggart',
	'staggers',
	'stargaze',
	'starters',
	'starvers',
	'stearate',
	'stedfast',
	'steerage',
	'steerers',
	'stewards',
	'strafers',
	'strasses',
	'stravage',
	'stressed',
	'stresses',
	'strettas',
	'strewers',
	'svedberg',
	'swabbers',
	'swaggers',
	'swatters',
	'swearers',
	'sweaters',
	'sweetest',
	'swervers',
	'tabarded',
	'tabarets',
	'taffetas',
	'targeted',
	'tartrate',
	'tarweeds',
	'tattered',
	'teacarts',
	'teawares',
	'teddered',
	'teetered',
	'terawatt',
	'terraced',
	'terraces',
	'terrases',
	'tesserae',
	'testates',
	'trabeate',
	'tractate',
	'traverse',
	'treaders',
	'treaters',
	'tweeters',
	'tweezers',
	'vedettes',
	'vegetate',
	'verderer',
	'vertebra',
	'vertexes',
	'waftages',
	'wagerers',
	'warcraft',
	'wardress',
	'warfares',
	'wastages',
	'waterage',
	'waterbed',
	'waterers',
	'wattages',
	'waverers',
	'waxweeds',
	'websters',
	'westered',
	'westward',
	'wresters',
	'zareebas',
];

exports.keyboard_9LetterWords = [
	'aberrated',
	'abreacted',
	'abscessed',
	'abscesses',
	'absterged',
	'absterges',
	'abstracts',
	'acerbated',
	'acerbates',
	'actresses',
	'addressed',
	'addressee',
	'addresser',
	'addresses',
	'affecters',
	'aftercare',
	'afterward',
	'aggravate',
	'aggregate',
	'aggressed',
	'aggresses',
	'arrearage',
	'arrestees',
	'arresters',
	'artefacts',
	'asserters',
	'attesters',
	'attracted',
	'avadavats',
	'baccarats',
	'barbettes',
	'barefaced',
	'barraters',
	'barrettes',
	'barterers',
	'bassetted',
	'bedsteads',
	'bedstraws',
	'bedwarfed',
	'beebreads',
	'beefeater',
	'beeswaxes',
	'befretted',
	'begetters',
	'bereavers',
	'berrettas',
	'besetters',
	'besteaded',
	'bestrewed',
	'betatters',
	'beverages',
	'bracteate',
	'braggarts',
	'brassages',
	'brassards',
	'brassarts',
	'brevetted',
	'cabrestas',
	'cabrettas',
	'cadasters',
	'cadastres',
	'caracaras',
	'carcasses',
	'cardcases',
	'careerers',
	'caressers',
	'cassettes',
	'castrated',
	'castrates',
	'cataracts',
	'cerebrate',
	'crabgrass',
	'crevassed',
	'crevasses',
	'databases',
	'deadbeats',
	'deaerated',
	'deaerates',
	'decreased',
	'decreases',
	'deerweeds',
	'defeaters',
	'defecated',
	'defecates',
	'deferrers',
	'degassers',
	'degraders',
	'degreased',
	'degreaser',
	'degreases',
	'desecrate',
	'deserters',
	'deservers',
	'detecters',
	'detergers',
	'deterrers',
	'detesters',
	'detracted',
	'devastate',
	'dewatered',
	'dewaterer',
	'dragsters',
	'dressages',
	'eastwards',
	'effecters',
	'eggbeater',
	'esterases',
	'estreated',
	'etceteras',
	'excavated',
	'excavates',
	'exceeders',
	'excreters',
	'execrated',
	'execrates',
	'extracted',
	'extravert',
	'federated',
	'federates',
	'ferreters',
	'fetterers',
	'feverfews',
	'freebased',
	'freebaser',
	'freebases',
	'gadgeteer',
	'gastraeas',
	'gazetteer',
	'gearcases',
	'graftages',
	'greegrees',
	'radwastes',
	'raggedest',
	'reacceded',
	'reaccedes',
	'readdress',
	'rearrests',
	'rearwards',
	'reasserts',
	'recreated',
	'recreates',
	'redbreast',
	'redefeats',
	'redefects',
	'redrafted',
	'redrawers',
	'redressed',
	'redresser',
	'redresses',
	'redstarts',
	'reerected',
	'referrers',
	'refracted',
	'refreezes',
	'regrafted',
	'regreeted',
	'regressed',
	'regresses',
	'regretted',
	'regretter',
	'rerewards',
	'reservers',
	'resetters',
	'restaffed',
	'restarted',
	'retardate',
	'retarders',
	'retargets',
	'retracted',
	'retreaded',
	'retreated',
	'retreater',
	'reversers',
	'reverters',
	'rewarders',
	'sassafras',
	'scabbards',
	'scattered',
	'scatterer',
	'seacrafts',
	'seafarers',
	'seawaters',
	'secretest',
	'seedcases',
	'seedeater',
	'seeresses',
	'segregate',
	'sesterces',
	'setscrews',
	'sewerages',
	'sextettes',
	'staggards',
	'staggarts',
	'staggered',
	'staggerer',
	'stargazed',
	'stargazer',
	'stargazes',
	'steadfast',
	'stearates',
	'steerages',
	'stewarded',
	'stravaged',
	'stravages',
	'streetcar',
	'svedbergs',
	'swaggered',
	'swaggerer',
	'tartrates',
	'teargases',
	'terawatts',
	'tesseract',
	'trabeated',
	'tractates',
	'traversed',
	'traverser',
	'traverses',
	'vegetated',
	'vegetates',
	'verderers',
	'vertebrae',
	'vertebras',
	'wadsetted',
	'warcrafts',
	'waterages',
	'waterbeds',
	'waterweed',
	'westwards',
	'zebrasses',
];

exports.keyboard_10LetterWords = [
	'abstracted',
	'abstracter',
	'addressees',
	'addressers',
	'aftercares',
	'aftertaste',
	'afterwards',
	'aggravated',
	'aggravates',
	'aggregated',
	'aggregates',
	'arrearages',
	'asseverate',
	'beefeaters',
	'beggarweed',
	'betattered',
	'casebearer',
	'cateresses',
	'cerebrated',
	'cerebrates',
	'degreasers',
	'desecrated',
	'desecrater',
	'desecrates',
	'devastated',
	'devastates',
	'dewaterers',
	'effervesce',
	'eggbeaters',
	'exacerbate',
	'exaggerate',
	'extraverts',
	'freebasers',
	'gadgeteers',
	'gazetteers',
	'rearrested',
	'reasserted',
	'reassessed',
	'reassesses',
	'redbreasts',
	'redefeated',
	'redefected',
	'redressers',
	'regretters',
	'restressed',
	'restresses',
	'retardates',
	'retargeted',
	'retreaters',
	'revegetate',
	'scabbarded',
	'scatterers',
	'seedeaters',
	'segregated',
	'segregates',
	'stagecraft',
	'staggerers',
	'stargazers',
	'statecraft',
	'stavesacre',
	'stewardess',
	'streetcars',
	'swaggerers',
	'sweetbread',
	'teargassed',
	'teargasses',
	'tesseracts',
	'tradecraft',
	'traversers',
	'vertebrate',
	'wardresses',
	'wastewater',
	'watercraft',
	'watercress',
	'waterweeds',
];

exports.keyboard_11LetterWords = [
	'abstracters',
	'abstractest',
	'aftereffect',
	'aftertastes',
	'asseverated',
	'asseverates',
	'beggarweeds',
	'casebearers',
	'crabgrasses',
	'decerebrate',
	'desecraters',
	'desegregate',
	'effervesced',
	'effervesces',
	'exacerbated',
	'exacerbates',
	'exaggerated',
	'exaggerates',
	'extravagate',
	'extravasate',
	'extraverted',
	'readdressed',
	'readdresses',
	'reaggregate',
	'resegregate',
	'revegetated',
	'revegetates',
	'reverberate',
	'sassafrases',
	'stagecrafts',
	'statecrafts',
	'stavesacres',
	'sweetbreads',
	'tradecrafts',
	'vertebrates',
	'wastewaters',
	'watercrafts',
];

exports.keyboard_12LetterWords = [
	'aftereffects',
	'decerebrated',
	'decerebrates',
	'desegregated',
	'desegregates',
	'extravagated',
	'extravagates',
	'extravasated',
	'extravasates',
	'reaggregated',
	'reaggregates',
	'resegregated',
	'resegregates',
	'reverberated',
	'reverberates',
	'stewardesses',
	'sweaterdress',
	'watercresses',
];

exports.keyboard_14LetterWords = ['sweaterdresses'];

exports.leftHandedWords = exports.keyboard_3LetterWords.concat(
	exports.keyboard_4LetterWords,
	exports.keyboard_5LetterWords,
	exports.keyboard_6LetterWords,
	exports.keyboard_7LetterWords,
	exports.keyboard_8LetterWords,
	exports.keyboard_9LetterWords,
	exports.keyboard_10LetterWords,
	exports.keyboard_11LetterWords,
	exports.keyboard_12LetterWords,
	exports.keyboard_14LetterWords
);

module.exports = exports;



// WEBPACK FOOTER //
// ./js/dicts/left_handed.js